import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json; charset=utf-8',
    })    
};

@Injectable()
export class ProctorService {

    constructor(private http: HttpClient) { }

    getStudents(rootUrl:string, usercode: string, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/students', {usercode: usercode, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getAssessor(rootUrl:string, usercode: string, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/assessor', {usercode: usercode, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getImagesGallary(rootUrl:string, usercode: string, entity_id:number, gallary_type:string,exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/images/gallary', {usercode: usercode, entity_id:entity_id, gallary_type:gallary_type,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getVideoGallary(rootUrl:string, usercode: string, entity_id:number, gallary_type:string,exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/video/gallary', {usercode: usercode, entity_id:entity_id, gallary_type:gallary_type,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getInformation(rootUrl:string, usercode: string, entity_id:number, info_type:string,exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/info', {usercode: usercode, entity_id:entity_id, info_type:info_type,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getExamExcelReport(rootUrl:string, usercode: string, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/exam/report/excel', {usercode: usercode, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getBatchExams(rootUrl:string, usercode: string, batch_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/batch/exams', {usercode: usercode, batch_id:batch_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    getBatchExamLink(rootUrl:string, batch_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/link/exams', { batch_id:batch_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    getExamStudents(rootUrl:string, usercode: string, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/exam/students', {usercode: usercode, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    getStudentsExamReport(rootUrl:string, usercode: string, student_id:number, exam_id:number, batch_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/student/exam/report', {usercode: usercode, student_id:student_id, exam_id:exam_id, batch_id:batch_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    getSessionToken(rootUrl:string, usercode:string, student_id:number, exam_id:number):Observable<any>{
        return this.http.post<any>(rootUrl+'proctor/student/session/token',{usercode: usercode, student_id:student_id, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    getStudentsForClient(rootUrl:string, exam_id:number, username:string, contact:number):Observable<any>{
        return this.http.post<any>(rootUrl+'proctor/client/login',{exam_id: exam_id, username:username, contact:contact}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    changeStudentLoginStatus(rootUrl:string, usercode:string, student_id:number):Observable<any>{
        return this.http.post<any>(rootUrl+'proctor/student/change/status', {usercode: usercode, student_id:student_id}, httpOptions)
            .pipe(map(response => {
                return response;
            })
        );
    }

    getSessiondata(rootUrl:string, usercode: string, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/student/livevideo', {usercode: usercode, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    // getSessiondata(rootUrl: string, usercode: string, exam_id: number): Observable<any> {
    //     return this.http.get<any>(rootUrl + 'proctor/student/livevideo/' + usercode + '/' + exam_id )
    //         .pipe(map(response => {
    //             return response;
    //         }));
    // }
    
    
}